import { ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';

export const fieldSchema: ISchemaFields = ({ valuesField, methods, formProps }) => {
  const { intl } = formProps || {};

  return {
    name: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'procedure.nameService' }),
      placeholder: intl.formatMessage({ id: 'procedure.nameServiceEnter' }),
      propsWrapper: { xs: true },
      style: { minWidth: 220 },
      register: {
        required: true,
      },
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'info',
      fields: ['name'],
    },
  ];
};

export const listServiceFormSchema: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
};
